import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./checkbox-input.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
class CheckboxInput extends PureComponent {
    isChecked() {
        var _this__input;
        return (_this__input = this._input) === null || _this__input === void 0 ? void 0 : _this__input.checked;
    }
    render() {
        const { inputData, id, defaultValue, onInputChange, translate } = this.props;
        const { inputName, text } = inputData;
        return /*#__PURE__*/ _jsxs("div", {
            id: id,
            className: `jsx-${componentStyles.__hash}` + " " + "consent-checkbox",
            children: [
                /*#__PURE__*/ _jsxs("label", {
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("input-title") || ""),
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            type: "checkbox",
                            defaultChecked: defaultValue,
                            name: inputName,
                            onChange: ()=>onInputChange({
                                    target: {
                                        name: inputName,
                                        value: this.isChecked()
                                    }
                                }),
                            ref: (input)=>this._input = input,
                            className: `jsx-${componentStyles.__hash}` + " " + "checkbox"
                        }),
                        translate(text)
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(CheckboxInput);
